module.exports = __webpack_public_path__ + "img/hs-01.396461de.svg";